import type { ReactNode } from "react";

import { ConfigProvider } from "antd";

import { theme as customTheme } from "../config/theme";

export const ThemeProvider = ({
  children,
  isEnabled = true,
}: {
  children: ReactNode;
  isEnabled?: boolean;
}) => {
  if (!isEnabled) {
    return <>{children}</>;
  }

  return <ConfigProvider theme={customTheme}>{children}</ConfigProvider>;
};
